import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-nuagedx-files-panel',
  templateUrl: './nuagedx-files-panel.component.html',
  styleUrls: ['./nuagedx-files-panel.component.scss'],
})
export class NuageDxFilesPanelComponent {
  @Input() visible: boolean = false;
  @Input() nuageDxFiles: any[] = [];

  @Output() closePanel = new EventEmitter<void>();

  handleClosePanel(): void {
    this.closePanel.emit();
  }

  backToClio(clioId: string): void {
    if (clioId) {
      window.open(`https://app.clio.com/documents/${clioId}`, '_blank');
    }
  }
}
